import 'react';
import Cookie from '../components/file-cookies/Cookie';
import ScrollToTopButton from '../ScrollToTopButton';

function PageCookie(): JSX.Element {
	return (
		<>
			<Cookie />

			<ScrollToTopButton />
		</>
	);
}
export default PageCookie;
